import { CLASS_ACTIVITY_ITEM } from '../constants';

export const CLASS_CARD_ACTIVITY_ITEM_DATE = CLASS_ACTIVITY_ITEM + '__date';
export const CLASS_CARD_ACTIVITY_ITEM_ADD_VALUE = CLASS_ACTIVITY_ITEM + '__add-value';
export const CLASS_CARD_ACTIVITY_ITEM_REMOVE_VALUE = CLASS_ACTIVITY_ITEM + '__remove-value';
export const CLASS_CARD_ACTIVITY_ITEM_DESCRIPTION = CLASS_ACTIVITY_ITEM + '__description';
export const CLASS_CARD_ACTIVITY_ITEM_DESCRIPTION_REMOVED = CLASS_CARD_ACTIVITY_ITEM_DESCRIPTION + '--removed';

export const COPY_PREFIX = 'Copy of';
